import { defineComponent as f, ref as S, computed as o } from "vue";
import d from "../../../trust_logos/ui/components/index.js";
import y from "./index6.js";
import g from "../../../country_selector/ui/components/index.js";
import { Variants as v } from "../../../country_selector/ui/types/index.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import { FooterStyle as e } from "../../../shared/data/layout/state/index3.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { useNavigationEventBus as b } from "@ado/acs-standard-library";
import B from "./index28.js";
import C from "./index29.js";
import { useBaseApplicationTranslation as L } from "../../../shared/libraries/local-translations/index.js";
const I = f({
  name: "FooterMobile",
  props: {
    disclaimerSettings: {
      type: Object,
      required: !0
    },
    countrySelectorSettings: {
      type: Object,
      required: !0
    },
    footerStyle: {
      type: String,
      default: e.Normal
    },
    notLoaded: {
      type: Boolean,
      default: !0
    },
    isQuebec: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const r = S(!1), n = o(
      () => t.footerStyle === e.Normal
    ), s = o(
      () => t.footerStyle === e.Simple
    ), m = o(
      () => t.footerStyle === e.SelectionPage
    ), a = o(
      () => t.disclaimerSettings.validate()
    ), l = function() {
      r.value = !r.value;
    }, i = L(), p = i.isLoaded, c = i.t, u = b();
    return {
      isNormalStyle: n,
      isSimpleStyle: s,
      isSelectionStyle: m,
      shouldShowDisclaimer: a,
      toggleCountryClass: l,
      countryVariant: v,
      isCountryDropdownActive: r,
      t: c,
      areTranslationsLoaded: p,
      navigationEventBus: u
    };
  },
  components: {
    CountrySelector: g,
    TrustLogos: d,
    Disclaimer: y,
    FooterMobileLinks: B,
    FooterSkeletonMobile: C
  }
});
export {
  I as default
};
//# sourceMappingURL=index19.js.map
